import React from 'react';
import { Calculator, TrendingUp, DollarSign, Target } from 'lucide-react';

export default function FlipAnalyzerMockup({ size = 'sm' }) {
  const isLg = size === 'lg';

  return (
    <div className={`w-full ${isLg ? 'p-4' : 'p-3'} bg-slate-800/80 rounded-xl`}>
      {/* Mini header */}
      <div className="flex items-center gap-2 mb-3">
        <div className="w-5 h-5 rounded bg-emerald-500/20 flex items-center justify-center">
          <Calculator size={11} className="text-emerald-400" />
        </div>
        <span className={`${isLg ? 'text-xs' : 'text-[10px]'} font-semibold text-white`}>
          Flip Analyzer
        </span>
      </div>

      <div className={`grid ${isLg ? 'grid-cols-2 gap-4' : 'grid-cols-2 gap-2'}`}>
        {/* Left: inputs */}
        <div className="space-y-1.5">
          {[
            { label: 'Asking Price', value: '$185,000' },
            { label: 'ARV', value: '$295,000' },
            { label: 'Rehab Cost', value: '$42,000' },
          ].map((field, i) => (
            <div
              key={i}
              className={`bg-slate-700/50 rounded-lg ${isLg ? 'px-3 py-2' : 'px-2 py-1.5'}`}
            >
              <p className="text-[8px] text-slate-500 uppercase tracking-wider mb-0.5">
                {field.label}
              </p>
              <p className={`${isLg ? 'text-sm' : 'text-[11px]'} font-bold text-white`}>
                {field.value}
              </p>
            </div>
          ))}
          {isLg && (
            <div className="bg-slate-700/50 rounded-lg px-3 py-2">
              <p className="text-[8px] text-slate-500 uppercase tracking-wider mb-0.5">
                Holding Months
              </p>
              <p className="text-sm font-bold text-white">6</p>
            </div>
          )}
        </div>

        {/* Right: results */}
        <div className="space-y-1.5">
          <div
            className={`bg-emerald-500/10 border border-emerald-500/20 rounded-lg ${isLg ? 'px-3 py-2.5' : 'px-2 py-1.5'}`}
          >
            <div className="flex items-center gap-1 mb-0.5">
              <TrendingUp size={9} className="text-emerald-400" />
              <p className="text-[8px] text-emerald-400/80 uppercase tracking-wider">Net Profit</p>
            </div>
            <p className={`${isLg ? 'text-lg' : 'text-sm'} font-extrabold text-emerald-400`}>
              $47,500
            </p>
          </div>
          <div
            className={`bg-blue-500/10 border border-blue-500/20 rounded-lg ${isLg ? 'px-3 py-2.5' : 'px-2 py-1.5'}`}
          >
            <div className="flex items-center gap-1 mb-0.5">
              <DollarSign size={9} className="text-blue-400" />
              <p className="text-[8px] text-blue-400/80 uppercase tracking-wider">ROI</p>
            </div>
            <p className={`${isLg ? 'text-lg' : 'text-sm'} font-extrabold text-blue-400`}>22.3%</p>
          </div>
          <div
            className={`bg-amber-500/10 border border-amber-500/20 rounded-lg ${isLg ? 'px-3 py-2.5' : 'px-2 py-1.5'}`}
          >
            <div className="flex items-center gap-1 mb-0.5">
              <Target size={9} className="text-amber-400" />
              <p className="text-[8px] text-amber-400/80 uppercase tracking-wider">Max Offer</p>
            </div>
            <p className={`${isLg ? 'text-lg' : 'text-sm'} font-extrabold text-amber-400`}>
              $189,500
            </p>
          </div>
        </div>
      </div>

      {/* Sensitivity row (lg only) */}
      {isLg && (
        <div className="mt-3 bg-slate-700/30 rounded-lg p-3">
          <p className="text-[9px] text-slate-500 uppercase tracking-wider font-semibold mb-2">
            Sensitivity Analysis
          </p>
          <div className="grid grid-cols-3 gap-2 text-center">
            {[
              { label: 'Conservative', profit: '$32,100', roi: '15.0%', color: 'text-amber-400' },
              { label: 'Expected', profit: '$47,500', roi: '22.3%', color: 'text-emerald-400' },
              { label: 'Optimistic', profit: '$63,800', roi: '29.8%', color: 'text-blue-400' },
            ].map((s, i) => (
              <div key={i} className="bg-slate-800/60 rounded-md px-2 py-1.5">
                <p className="text-[8px] text-slate-500 mb-0.5">{s.label}</p>
                <p className={`text-xs font-bold ${s.color}`}>{s.profit}</p>
                <p className="text-[9px] text-slate-500">{s.roi}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
